import { FC, useContext, useState } from "react";
import { Address } from "../../../../../shared/interfaces/address";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import Loader from "../../../../../shared/components/loader/linearProgress";
import DataTable from "../../../../../shared/components/dataTable";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import AddressView from "./addressView";

interface AddressListProps {
  organizationId: string;
  entityPermissions: string[];
}

  const AddressList: FC<AddressListProps> = ({organizationId, entityPermissions}) => {
  const { payload, setPayload } = useContext(SidebarContext);
  const { loading: addressLoading, data: addressData, error } = useQuery(
    "/admin/organization-addresses",
    {
      params: {
        ...payload,
        entityId: organizationId,
         entityType: "Organization"
      },
    }
  );
  const [selectedAddressId, setSelectedAddressId] = useState<string | null>(
    null
  );


  let addressList: Address[] = [];
  if (addressData && (addressData as any)?.items) {
    addressList = (addressData as any)?.items.map((item: any) => {
      return {
        id: item.id,
        addressLine1: item.addressLine1,
        streetName: item.streetName,
        zipCode: item.zipCode,
        state: item.state?.map((s: any) => s.label),
        city: item.city?.map((c: any) => c.label),
        country: item.country?.map((c: any) => c.label),
        default: item.defaultAddress === true ? 'Yes' : 'No'
      }
    });
  }

  const addressDisplayColumns = ["addressLine1", "streetName", "country", "zipCode", "default"];
  const titleBar = {
    title: "",
    headerTitle: "",
    filter: false,
    disabled:  entityPermissions
    ? !entityPermissions?.includes("Reseller-Create")
    : false,
    titleBarNodes: (
      <>
        <SearchBox />
      </>
    ),
  };
  const handleRowClick = (rowData: Address) => {
    setSelectedAddressId(rowData.id);
  };
  return (
    <>
        {selectedAddressId ? (
        <AddressView
          id={selectedAddressId}
          onClose={() => setSelectedAddressId(null)} // Pass close handler
        />
      ) : (
      <TableViewContainer titleBar={titleBar}>
        {addressLoading && <Loader />}
        {(error as any)?.statusCode === 403 && <NoPermissionContent />}
        {!addressLoading && !error && (

          <DataTable
            entityName="Address"
            data={addressList}
            displayColumns={addressDisplayColumns}
            linkColumn="address"
            linkUrl="/resellers/resellerAddress"
            pagination={{ take: payload.take, skip: payload.skip }}
            setPagination={setPayload}
            totalItems={(addressData as any)?.totalItems}
            renderCell={(row, column) => (
              <div
              onClick={(e) => {
                e.stopPropagation(); 
                handleRowClick(row);
              }}
              style={{ cursor: "pointer" }} 
            >
              {row[column]}
            </div>
            )}
        
          />
        )}
      </TableViewContainer>
      )}
    </>
  );
};

export default AddressList;
